import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronLeft, Mail, MapPin } from 'lucide-react';
import { useVenue } from '../../contexts/VenueContext';
import { fetchSelectedVenueApplication } from '../../utils/venueAppApi';
import { RouteTransitionLogo } from '../../components/RouteTransitionLogo';
import { useBackTarget } from '../../hooks/useBackTarget';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;
const font = "'Inria Serif', serif";

export default function VenueContactDetailsPage() {
  const navigate = useNavigate();
  const goBack = useBackTarget();
  const { activeVenueAppId } = useVenue();
  const [details, setDetails] = useState({ contact_email: '', street: '', city: '', country: '' });

  useEffect(() => {
    const fetch = async () => {
      try {
        const app = await fetchSelectedVenueApplication(activeVenueAppId);
        if (app) {
          const d = {
            contact_email: app.contact_email || '',
            street: app.street || '', city: app.city || '', country: app.country || '',
          };
          setDetails(d);
        }
      } catch (err) { console.error(err); }
    };
    fetch();
  }, [activeVenueAppId]);

  return (
    <div className="app-shell" style={{ minHeight: '100vh', backgroundColor: 'var(--app-bg)', display: 'flex', flexDirection: 'column', alignItems: 'center', paddingBottom: 40 }}>
      <div style={{ width: '100%', maxWidth: 390, display: 'flex', justifyContent: 'space-between', padding: '16px 20px 0' }}>
        <button onClick={goBack} style={{ background: 'none', border: 'none', cursor: 'pointer' }}><ChevronLeft size={30} color="#000" strokeWidth={2} /></button>
        <div />
      </div>
      <div style={{ marginTop: 8 }}>
        <RouteTransitionLogo width={100} height={89} dataTestId="venue-contact-details-shared-logo" />
      </div>
      <h2 style={{ fontFamily: font, fontSize: 26, fontWeight: 700, color: 'var(--text)', marginTop: 8, marginBottom: 16 }}>Contact Details</h2>

      <div style={{ width: '100%', maxWidth: 340, padding: '0 16px' }}>
        {/* Email */}
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: 12, padding: '12px 0', borderBottom: '1px solid #F0F0F0' }}>
          <Mail size={20} color="#555" />
          <div style={{ flex: 1 }}>
            <p style={{ fontFamily: font, fontSize: 14, color: 'var(--text-3)', margin: '0 0 2px' }}>Email</p>
            <p data-testid="venue-contact-email-value" style={{ fontFamily: font, fontSize: 17, fontWeight: 700, color: 'var(--text)', margin: 0 }}>{details.contact_email || '—'}</p>
          </div>
        </div>
        {/* Address - not editable */}
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: 12, padding: '12px 0', borderBottom: '1px solid #F0F0F0' }}>
          <MapPin size={20} color="#555" />
          <div style={{ flex: 1 }}>
            <p style={{ fontFamily: font, fontSize: 14, color: 'var(--text-3)', margin: '0 0 2px' }}>Address (not editable)</p>
            <p style={{ fontFamily: font, fontSize: 17, fontWeight: 700, color: 'var(--text)', margin: 0 }}>{`${details.street}, ${details.city}, ${details.country}`}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
